module.exports = __webpack_public_path__ + "static/phone-f8fb1ffaa938b11a48456c21729e4f4c.png";